import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { fmtDate } from "../lib/helpers";
import { Section, Empty } from "./common";

export function ReviewStats() {
  const { t, lang } = useLang();
  const [d, setD] = useState(null);
  const load = () => api.get("/reviews").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!d) return null;
  const s = d.stats;
  const resolve = async (x) => {
    const note = window.prompt(t("How was it resolved? (optional)", "¿Cómo se resolvió? (opcional)"));
    if (note === null) return;
    try { await api.post(`/reviews/${x.id}/resolve`, { note }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const cards = [["sent", t("Requests sent", "Solicitudes enviadas"), s.sent], ["answered", t("Surveys answered", "Encuestas respondidas"), s.answered], ["avg", t("Average rating", "Calificación promedio"), s.avg_rating ?? "—"], ["google", t("Went to Google", "Fueron a Google"), s.google_clicks], ["rate", t("Response rate", "Tasa de respuesta"), `${s.response_rate}%`], ["issues", t("Open issues", "Problemas abiertos"), s.issues_open]];
  const issues = d.items.filter((x) => x.issue_status === "open");
  return (
    <Section title={t("Google reviews & satisfaction", "Reseñas de Google y satisfacción")} testid="report-reviews">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 p-4">{cards.map(([k, l, v]) => <div key={k} className="rounded-xl bg-slate-50 p-3" data-testid={`review-stat-${k}`}><div className="text-xs text-slate-500">{l}</div><div className="mono font-bold text-lg">{v}</div></div>)}</div>
      <div className="px-4 pb-1 text-xs font-bold uppercase text-slate-500">{t("Unhappy customers to follow up", "Clientes insatisfechos por atender")}</div>
      {!issues.length && <Empty text={t("No open issues", "Sin problemas abiertos")} />}
      {issues.map((x) => (
        <div key={x.id} className="px-4 py-2 border-t flex items-center gap-2 text-sm" data-testid={`review-issue-${x.id}`}>
          <Link to={`/customers/${x.customer_id}`} className="flex-1 min-w-0"><div className="font-semibold truncate">{x.customer_name} · {x.rating}/5</div><div className="text-xs text-slate-500 truncate">{fmtDate(x.answered_at, lang)} · {x.feedback || "—"}</div></Link>
          <button className="btn-outline btn-sm" onClick={() => resolve(x)} data-testid={`review-resolve-${x.id}`}>{t("Resolved", "Resuelto")}</button>
        </div>
      ))}
    </Section>
  );
}
